module.exports = __webpack_public_path__ + "img/TZS09693.7998b09e.jpeg";